import { apiRequest } from './api';

export const getLeaderboards = () =>
  apiRequest('GET', '/leaderboards');

export const getLeaderboard = (id: string) =>
  apiRequest('GET', `/leaderboards/${id}`);

export const getLeaderboardEntries = (id: string) =>
  apiRequest('GET', `/leaderboards/${id}/entries`);

export const createLeaderboard = (data: any) =>
  apiRequest('POST', '/leaderboards', data);

export const updateLeaderboard = (id: string, data: any) =>
  apiRequest('PUT', `/leaderboards/${id}`, data);

export const submitLeaderboardEntry = (id: string, data: any) =>
  apiRequest('PUT', `/leaderboards/${id}/entries`, data);

export const deleteLeaderboard = (id: string) =>
  apiRequest('DELETE', `/leaderboards/${id}`);


// Console accessible debug methods available in development mode
if(process.env.NODE_ENV === 'development') {
  window.getLeaderboards = getLeaderboards;
  window.getLeaderboard = getLeaderboard;
  window.getLeaderboardEntries = getLeaderboardEntries;
  window.createLeaderboard = createLeaderboard;
  window.updateLeaderboard = updateLeaderboard;
  window.submitLeaderboardEntry = submitLeaderboardEntry;
  window.deleteLeaderboard = deleteLeaderboard;
}